import { useCallback, useEffect, useState } from "react";
import { sendBackClickMessage } from "@/betby/models/host/unityMessageService";
import LogUtil from "@/betby/utils/LogUtil";

export function useLoadingViewModel(visible: boolean) {
  const [progress, setProgress] = useState(0);

  const handleBack = useCallback(() => {
    LogUtil.debug("Back clicked");
    sendBackClickMessage();
  }, []);

  useEffect(() => {
    if (!visible) {
      const resetFrameId = requestAnimationFrame(() => {
        setProgress(0);
      });
      return () => {
        cancelAnimationFrame(resetFrameId);
      };
    }

    const duration = 1500;
    const startTime = Date.now();
    let animationFrameId: number;

    const animate = () => {
      const elapsed = Date.now() - startTime;
      const nextProgress = Math.min((elapsed / duration) * 100, 100);

      setProgress(nextProgress);

      if (nextProgress < 100) {
        animationFrameId = requestAnimationFrame(animate);
      }
    };

    animationFrameId = requestAnimationFrame(animate);

    return () => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
    };
  }, [visible]);

  return {
    handleBack,
    progress,
  };
}
